// https://vuex.vuejs.org/en/getters.html

export default {
  clients(state) {
    return state.clients;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  },
  downloadList(state){
    return state.downloadList
  }
};
